import { IListItem } from 'models/common';

export class ListItemTranslator {
  constructor(private loadedData: IListItem[], private fallbackData: IListItem[]) {}

  public get(key: string): string {
    return ((this.loadedData || this.fallbackData).find((item) => item.TypeId === key)?.Translation ||
      this.fallbackData.find((item) => item.TypeId === key)?.Translation) as string;
  }
}
